export default {
  try: {
    en: 'Try it now',
  },
  all: {
    en: 'All products',
  },
  addToQueue: {
    en: 'Add to queue',
  },
}
